import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { errorMessageAreaStyles } from "./styles/business-components";

export const RegisterError = () => {
  const [queryParameters] = useSearchParams()
  const code = queryParameters.get("code")
  const { t } = useTranslation();

  return (
    <Box>
      <Box sx={errorMessageAreaStyles.main}>
        <Typography>{t('registerError.registerFailed')}: {code}</Typography>
        <Typography>{t('registerError.incorrectCode')}</Typography>
        <Typography>{t('registerError.codeExpired')}</Typography>
      </Box>
    </Box>
    // {!isAuthenticated && <p><button type="button" className="btn btn-primary" onClick={() => login('/profile')}>Login</button></p>}
    // {/* {isAuthenticated && <p><button type="button" className="btn btn-primary" onClick={() => logout('/profile')}>logout /profile</button></p>} */}
    // {/* {isAuthenticated && <p><button type="button" className="btn btn-primary" onClick={() => getUsers()}>Get Users</button></p>} */}
    // {/* {isAuthenticated && <p><button type="button" className="btn btn-primary" onClick={() => logout()}>logout</button></p>} */}
    // {/* {isAuthenticated && <p><button type="button" className="btn btn-primary" onClick={() => logout(null)}>logout whithout callbackredirect</button></p>} */}
    // {isAuthenticated && <p><button type="button" className="btn btn-primary" onClick={async () => console.log('renewTokens result', await renewTokens())}>renew tokens</button></p>}
  );
};

export default RegisterError;
